<template>
  <div class="wrapper">
    <dashboard-bar refreshButton :noAllPeriod="true" />
    <div class="wrapp">
      <div class="row">
        <div class="col-12">
          <span class="header-icon">
            <font-awesome-icon :icon="['fas', 'address-book']" />
          </span>
          <h2>{{ $t('clients.pageTitle') }}</h2>
        </div>
      </div>
      <div class="row mt-2 pl-3"><strong>Pesquisar por</strong></div>
      <div class="row">
        <div class="col-12">
          <div class="form-inline">
            <b-form-select
              class="mt-3 mr-3"
              v-model="searchType"
              @change="setSearchType"
              :options="searchOptions"
            ></b-form-select>
            <div class="form-group col-3 mt-3 pl-0 pr-0">
              <input
                style="width: 100%;"
                type="text"
                class="form-control"
                :placeholder="$t('clients.searchInput')"
                @keyup="searchTerm"
                v-model="search"
              />
            </div>
            <button
              @click="
                search = null;
                setData();
              "
              type="button"
              class="btn btn-outline-primary mt-3 ml-1"
            >
              {{ $t('clients.searchButton') }}
            </button>
          </div>
        <perfect-scrollbar>
          <b-table
            striped
            small
            id="manual-table"
            class="mt-4"
            :items="items"
            :fields="fields"
            :busy="loading"
            @sort-changed="sortingChanged"
            no-local-sorting
            style="font-size: 16px; white-space: nowrap;"
          >
            <template v-slot:table-busy>
              <div class="text-center text-primary my-2">
                <b-spinner type="grow" class="align-middle"></b-spinner>
              </div>
            </template>
            <!-- Nome -->
            <template v-slot:cell(name)="row">
              {{ checkUserData(row.item, row.item.name) }}
            </template>
            <!-- Email -->
            <template v-slot:cell(email)="row">
              {{ checkUserData(row.item, row.item.email) }}
            </template>
            <!-- Telefone -->
            <template v-slot:cell(phone)="row">
              {{ checkUserData(row.item, row.item.phone) }}
            </template>
            <!-- Ação -->
            <template v-slot:cell(actionId)="row">
              {{ row.item.actionId.name }}
            </template>
            <!-- Status -->
            <template v-slot:cell(active)="row">
              {{ getActive(row.item.active) }}
            </template>
            <!-- Respondido -->
            <template v-slot:cell(answered)="row">
              {{ getAnswered(row.item.answered) }}
            </template>
            <!-- Importação -->
            <template v-slot:cell(createdAt)="row">
              {{ dateFormat(new Date(row.item.createdAt)) }}
            </template>
            <!-- Último Lembrete -->
            <template v-slot:cell(lastReminder)="row" >
              {{ getLastReminder(row.item.reminderDates) }}
            </template>
            <!-- Qtde Lembretes -->
            <template v-slot:cell(qtdReminder)="row">
              {{ getQtdReminder(row.item.reminderDates) }}
            </template>
            <!-- Editar campos -->
            <template
              v-slot:cell(editReminder)="row"
              v-if="userProfile.permissions.clients.edit_data"
            >
              <a @click="getData(row.item)">
                <font-awesome-icon
                  class="btn-edit-reminder"
                  :icon="['fas', 'pen']"
                />
              </a>
            </template>
          </b-table>
        </perfect-scrollbar>
          <!-- modal edit reminder -->
          <b-modal
            size="lg"
            ref="edit-reminder"
            title="Dados do convite"
            @ok="saveDataModal"
          >
            <p>Alterar dados do convite.</p>

            <div style="height: 300px; overflow: scroll;">
              <div class="container">
                <div class="row column-form">
                  <div class="col-5"><b>Campo</b></div>
                  <div class="col-5"><b>Valor</b></div>
                </div>
              </div>

              <div class="form-inline-modal">
                <div class="col-5">Nome</div>
                <div v-if="modalEdit.anonymous" class="col-5">
                  <input
                    disabled
                    class="size-input form-control"
                    type="text"
                    value="**********"
                  />
                </div>
                <div v-else class="col-5">
                  <input
                    :disabled="modalEdit.answered"
                    class="size-input form-control"
                    type="text"
                    v-model="modalEdit.name"
                  />
                </div>

                <div class="col-5">Email</div>
                <div v-if="modalEdit.anonymous" class="col-5">
                  <input
                    disabled
                    class="size-input form-control"
                    type="text"
                    value="**********"
                  />
                </div>
                <div v-else class="col-5">
                  <input
                    :disabled="modalEdit.answered"
                    class="size-input form-control"
                    type="text"
                    v-model="modalEdit.email"
                  />
                </div>

                <div class="col-5">Telefone</div>
                <div v-if="modalEdit.anonymous" class="col-5">
                  <input
                    disabled
                    class="size-input form-control"
                    type="text"
                    value="**********"
                  />
                </div>
                <div v-else class="col-5">
                  <input
                    :disabled="modalEdit.answered"
                    class="size-input form-control"
                    type="text"
                    v-model="modalEdit.phone"
                  />
                </div>

                <div
                  style="display: flex; width: 100%;"
                  v-for="(data, indexData) in modalEdit.indicators"
                  :key="indexData"
                >
                  <div class="col-5" style="margin-top: 8px;">
                    {{ data.column }}
                  </div>
                  <div class="col-5">
                    <input
                      v-if="data.anonymous && modalEdit.anonymous"
                      class="size-input form-control"
                      type="text"
                      :disabled="true"
                      placeholder="**********"
                    />
                    <input
                      v-else
                      class="size-input form-control"
                      type="text"
                      v-model="data.value"
                    />
                  </div>
                </div>
              </div>
            </div>
          </b-modal>
          <div v-show="!loading" class="footer">
            <div class="pagination-area-clients mt-1">
              <paginate
                :pageCount="myClients.documents"
                :clickHandler="setData"
                :prevText="'‹'"
                :nextText="'›'"
                :activeClass="'active'"
                :containerClass="'pagination b-pagination'"
                :pageClass="'page-item'"
              ></paginate>
            </div>
            <div class="row d-flex justify-content-end mr-2">
              <div class="mr-3">
                <div
                  v-if="loadingDownloadIconCsv"
                  class="text-center text-primary my-2"
                >
                  <b-spinner type="grow" class="align-middle"></b-spinner>
                </div>
                <a v-else :title="$t('clients.exportCsv')">
                  <b-dropdown
                    variant="link"
                    toggle-class="text-decoration-none dropdown-csv"
                    no-caret
                  >
                    <template #button-content>
                      <span class="xls">
                        <i class="fas fa-file-csv"></i>
                      </span>
                    </template>
                    <b-dropdown-item @click="exportData('csv', 'comma')">{{
                      $t('clients.csvCommaSeparator')
                    }}</b-dropdown-item>
                    <b-dropdown-item @click="exportData('csv', 'pipe')">{{
                      $t('clients.csvPipeSeparator')
                    }}</b-dropdown-item>
                  </b-dropdown>
                </a>
              </div>
              <div>
                <div
                  v-if="loadingDownloadIconXls"
                  class="text-center text-primary my-2"
                >
                  <b-spinner type="grow" class="align-middle"></b-spinner>
                </div>
                <a
                  v-else
                  @click="exportData('xlsx', null)"
                  :title="$t('clients.exportXls')"
                >
                  <span class="xls">
                    <i class="fas fa-file-excel"></i>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { format } from 'date-fns';
import pt from 'date-fns/locale/pt';
import Paginate from 'vuejs-paginate';
import swal from 'sweetalert';
import dashboardBar from '@/components/molecules/dashboard-bar';
import api from '@/services/api';

import Vue from 'vue'
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'


Vue.use(PerfectScrollbar)

export default {
  name: 'Clients',

  components: {
    Paginate,
    dashboardBar,
  },

  data: () => ({
    sortBy: null,
    sortDesc: null,
    downloadType: null,
    userAuth: null,
    typingTimer: null,
    doneTypingInterval: 600,
    search: null,
    loading: true,
    page: 1,
    loadingDownloadIconXls: false,
    loadingDownloadIconCsv: false,
    dates: {
      start: null,
      end: null,
    },
    fields: [],
    items: [],
    modalEdit: {},
    searchType: 'controlId', // default
    searchOptions: [],
  }),

  watch: {
    actionGroupData: function watchactionGroup() {
      this.setData();
    },
    myActionId: function watchMyActionId() {
      this.setData();
    },
    myActionsIds: function watchMyActionsIds() {
      this.setData();
    },
    myIh1: function watchMyIh1() {
      this.setData();
    },
    myHierarchies1: function watchMyHierarchies1(){
      this.setData();
    },
    myIh2: function watchMyIh2() {
      this.setData();
    },
    myHierarchies2: function watchMyHierarchies2(){
      this.setData();
    },
    calendarDates: function watchCalendarDates() {
      this.setData();
    },
    'indicatorData.value': function watchIndicatorData() {
      this.setData();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      await this.setData();
    },
  },

  computed: {
    ...mapState('clients', ['myClients']),
    ...mapState('actions', ['myActionId', 'actionGroupData', 'action', 'myActionsIds']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('branches', ['myIh1', 'myIh2', 'myHierarchies1', 'myHierarchies2']),
    ...mapState('authentication', ['userProfile']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
    ...mapState('companies', ['myMetric']),
  },

  methods: {
    ...mapActions('clients', ['setClients', 'updateDateRange']),
    ...mapActions('calendar', ['setDates']),

    setSearchType(value) {
      this.searchType = value;
    },
    async saveDataModal() {
      const modalEdit = {
        ...this.modalEdit,
        indicators: this.modalEdit.indicators.map((a) => {
          return { _id: a._id, value: a.value };
        }),
      };
      await api.put(
        `/update-invite/${modalEdit.controlId}`,
        {
          name: modalEdit.anonymous ? null : modalEdit.name,
          email: modalEdit.anonymous ? null : modalEdit.email,
          phone: modalEdit.anonymous ? null : modalEdit.phone,
          indicators: this.modalEdit.indicators,
        },
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        },
      );
      swal({
        title: 'Sucesso',
        text: 'Dados atualizados!',
        icon: 'success',
      });
      this.setData();
    },

    async getData(item) {
      // get all the action indicators
      let actionIndicators = [];
      const resIndicators = await api.get(`invites/indicators/${item._id}`, {
        headers: { 'x-access-token': this.userAuth.token },
      });

      const indicators = resIndicators.data || [];

      const response = await api.get(`indicator/${item.actionId._id}`, {
        headers: { 'x-access-token': this.userAuth.token },
      });
      if (response.data) {
        actionIndicators = response.data;
      }
      let achou;
      // add the actionIndicators that doesn't exist in invite
      for (let i = 0; i < actionIndicators.length; i += 1) {
        achou = false;
        for (let j = 0; j < indicators.length; j += 1) {
          if (indicators[j].indicatorId === actionIndicators[i]._id) {
            indicators[j].types = actionIndicators[i].types;
            achou = true;
            break;
          }
        }
        if (!achou) {
          indicators.push({
            column: actionIndicators[i].key,
            indicatorId: actionIndicators[i]._id,
            key: '',
            value: '',
            types: actionIndicators[i].types,
          });
        }
      }
      // update page info and show modal
      this.modalEdit = {
        controlId: item.controlId,
        name: item.name,
        email: item.email,
        phone: item.phone,
        indicators,
        answered: item.answered,
        anonymous: item.anonymousResponse,
      };
      this.$refs['edit-reminder'].show();
    },

    checkUserData(item, value) {
      if (
        this.userProfile.permissions.clients.anonymous_profile ||
        item.anonymousResponse
      ) {
        return '***************';
      } else if (value) {
        return value;
      }
      return '-';
    },

    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.setData();
    },

    async searchTerm() {
      if (
        this.search !== '' &&
        this.search !== null &&
        this.searchType !== null
      ) {
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(this.setData, this.doneTypingInterval);
      }

      if (this.search === '') {
        this.search = null;
        this.setData();
      }
    },

    async setData(page) {
      this.loading = true;

      this.setClients({
        companyId: this.userAuth.companyId,
        token: this.userAuth.token,
        actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
        startDate: this.calendarDates.start,
        endDate: this.calendarDates.end,
        ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
        ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
        groupId: this.actionGroupData._id,
        page: page || this.page,
        limit: 10,
        term: this.search,
        searchType: this.searchType,
        sortDesc: this.sortDesc,
        sortBy: this.sortBy,
        indicator: this.indicatorName,
        indicatorValue: this.indicatorData.value,
        indicatorRange: this.indicatorData.range,
        metric: this.myMetric ? this.myMetric : null,
      }).then(() => {
        this.loading = false;
        this.items = this.myClients.items;
      });
    },

    async exportData(type, csvSeparator) {
      // checks if the total docs to download is greater then 500k
      if (this.myClients.documents * 10 > 500000) {
        swal({
          title: this.$t('scheduling.messages.maxDownloadError.title'),
          text: this.$t('scheduling.messages.maxDownloadError.description'),
          icon: 'warning',
        });
        return;
      }

      if (type === 'xlsx') {
        this.loadingDownloadIconXls = true;
      } else {
        this.loadingDownloadIconCsv = true;
      }

      if (csvSeparator === 'comma') {
        csvSeparator = ',';
      }
      if (csvSeparator === 'pipe') {
        csvSeparator = '|';
      }

      this.apiServerlessDownloads = process.env.API_SERVERLESS_DOWNLOADS;

      try {
        await api.get(
          `${this.apiServerlessDownloads}/download/clients/${this.userAuth.companyId}/${type}`,
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
            params: {
              startDate: this.calendarDates.start,
              endDate: this.calendarDates.end,
              metric: this.myMetric ? this.myMetric : null,
              actionId: this.myActionsIds.length === 0 ? null : JSON.stringify(this.myActionsIds),
              ih1: this.myHierarchies1.length === 0 ? null : JSON.stringify(this.myHierarchies1),
              ih2: this.myHierarchies2.length === 0 ? null : JSON.stringify(this.myHierarchies2),
              groupId: this.actionGroupData._id,
              search: this.search,
              indicator: this.indicatorName,
              indicatorValue: this.indicatorData.value,
              indicatorRange: this.indicatorData.range,
              csvSeparator,
            },
          },
        );

        swal({
          title: this.$t('clients.messages.export.title'),
          text: this.$t('clients.messages.export.description'),
          icon: 'success',
        });
      } catch (error) {
        swal({
          title: this.$t('clients.messages.error.title'),
          text: error.response.data.message,
          icon: 'error',
        });
      }

      if (type === 'xlsx') {
        this.loadingDownloadIconXls = false;
      } else {
        this.loadingDownloadIconCsv = false;
      }
    },

    dateFormat(param) {
      const date = format(param, 'dd/MM/yyyy HH:mm', { locale: pt });
      return date;
    },

    getActive(active) {
      return active
        ? this.$t('clients.clientsTable.statusYes')
        : this.$t('clients.clientsTable.statusNo');
    },

    getAnswered(answered) {
      return answered
        ? this.$t('clients.clientsTable.answeredYes')
        : this.$t('clients.clientsTable.answeredNo');
    },

    getLastReminder(reminder) {
      if (reminder.length > 0) {
        return this.dateFormat(new Date(reminder[reminder.length - 1]));
      }
      return null;
    },

    getQtdReminder(reminder) {
      return reminder.length;
    },

    makeToast(message, title, append = false) {
      this.toastCount += 1;
      this.$bvToast.toast(`${message}`, {
        title,
        autoHideDelay: 5000,
        appendToast: append,
      });
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    if (!this.userProfile.permissions.clients.menu) {
      this.$router.push(`/dashboard/${this.userAuth.companyId}`);
    }
    this.fields = [
      {
        key: 'controlId',
        label: this.$t('clients.clientsTable.labels.id'),
        visible: true,
      },
      {
        key: 'name',
        label: this.$t('clients.clientsTable.labels.name'),
        visible: true,
      },
      {
        key: 'email',
        label: this.$t('clients.clientsTable.labels.email'),
        visible: true,
      },
      {
        key: 'phone',
        label: this.$t('clients.clientsTable.labels.phone'),
        visible: true,
      },
      {
        key: 'actionId',
        label: this.$t('clients.clientsTable.labels.lastAction'),
        visible: true,
      },
      {
        key: 'active',
        label: this.$t('clients.clientsTable.labels.status'),
        visible: true,
      },
      {
        key: 'answered',
        label: this.$t('clients.clientsTable.labels.answered'),
        visible: true,
      },
      {
        key: 'createdAt',
        label: this.$t('clients.clientsTable.labels.lastImportation'),
        visible: true,
      },
      {
        key: 'lastReminder',
        label: this.$t('clients.clientsTable.labels.lastReminder'),
        visible: true,
      },
      {
        key: 'qtdReminder',
        label: this.$t('clients.clientsTable.labels.reminders'),
        visible: true,
      },
      {
        key: 'editReminder',
        label: this.$t('clients.clientsTable.labels.editReminder'),
        visible:
          this.userProfile.permissions.clients.edit_data ||
          this.userAuth.permissions.type === 'master' ||
          this.userAuth.permissions.type === 'admin'
            ? true
            : false,
      },
    ];
    this.fields = this.fields.filter((field) => field.visible);

    this.searchOptions = [
      {
        text: this.$t('clients.clientsTable.searchOptions.id'),
        value: 'controlId',
      },
      {
        text: this.$t('clients.clientsTable.searchOptions.clientId'),
        value: 'clientId',
      },
      {
        text: this.$t('clients.clientsTable.searchOptions.email'),
        value: 'email',
      },
      {
        text: this.$t('clients.clientsTable.searchOptions.name'),
        value: 'name',
      },
      {
        text: this.$t('clients.clientsTable.searchOptions.phone'),
        value: 'phone',
      },
    ];
  },

  mounted() {
    this.setData();
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
@import '@/themes/default/placeholders.scss';

.column-form {
  height: 40px;
  padding-top: 5px;
}

.size-input {
  width: 100%;
  min-width: 100%;
}

.form-inline-modal {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}

.form-inline-modal label {
  margin: 5px 10px 5px 0;
}

.form-inline-modal input {
  vertical-align: middle;
  margin: 5px 10px 5px 0;
  padding: 10px;
  border: 1px solid #ddd;
}

.form-inline-modal button {
  padding: 10px 20px;
  background-color: dodgerblue;
  border: 1px solid #ddd;
  color: white;
  cursor: pointer;
}

.form-inline-modal button:hover {
  background-color: royalblue;
}

@media (max-width: 800px) {
  .form-inline-modal input {
    margin: 10px 0;
  }

  .form-inline-modal {
    flex-direction: column;
    align-items: stretch;
  }
}

.btn-edit-reminder {
  color: #4ce595;
  padding-left: 5px;
  font-size: 24px;
  cursor: pointer;
}

.wrapper {
  padding: 8px;
}

.wrapp {
  background-color: $white;
  border-radius: 4px;
  border: 1px solid $gray-light;
  @each $i in $directions {
    @extend %default-padding-#{$i};
  }
  @extend %half-padding-bottom;

  h2 {
    text-transform: uppercase;
    font-size: 21px;
    font-weight: 100;
    color: $gray;
  }

  .header-icon {
    float: left;
    font-size: 12px;
    margin-top: 4px;
    padding-right: 12px;
    color: $gray;
  }

  .refresh-icon {
    margin-top: 1px;
    color: $primary;
    cursor: pointer;
    &:hover {
      color: green;
    }
  }
}

.footer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.xls {
  font-size: 35px;
  color: $primary;
  cursor: pointer;
}

.xls:hover {
  color: #1dc86e;
}

.pagination-area-clients >>> a {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #4ce595;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
</style>

<style>
.pagination-area-clients .active a {
  text-decoration: none;
  z-index: 1;
  color: #fff;
  background-color: #4ce595;
  border-color: #4ce595;
}

.pagination-area-clients a {
  outline: none;
}

.dropdown-csv {
  border: 0px;
  padding: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/clients/index.vue